import React from 'react'
import {Alert} from "react-bootstrap";


export default class DisplayStatus extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            showAlert: props.showAlert
        }

        this.handleDismiss = this.handleDismiss.bind(this);
        DisplayStatus.statusMessage = DisplayStatus.statusMessage.bind(this)
    }

    componentDidMount() {
        this.setState({ showAlert: this.props.showAlert });
    }


    componentDidUpdate(prevProps, prevState) {
        if (prevProps.showAlert !== this.props.showAlert) {
            this.setState({ showAlert: this.props.showAlert });
        }
    }

    handleDismiss() {
        this.props.handleAlert(false)
    }

    render() {
        if (this.props.statusMessage) {
            const statusMessage = this.props.statusMessage
            let className = 'alert alert-' + DisplayStatus.statusMessage(this.props.statusType).className
            let icon = 'fa fa-' +  DisplayStatus.statusMessage(this.props.statusType).icon
            return (
                <React.Fragment>
                    {this.state.showAlert ?
                    <Alert className={className} dismissible={this.props.dismissible} onClose={this.handleDismiss}>
                        <span className={"alert-icon " + icon}></span>
                        <span>&nbsp;&nbsp;{statusMessage}</span>
                    </Alert>:null}
                </React.Fragment>
            )
        } else {
            return null
        }
    }


    static statusMessage(type)
    {
        switch (type) {
            case "error":
                return {className: "danger", icon: "exclamation-triangle"}
            case "unknownError":
                return {className: "danger", icon: "exclamation-triangle"}
            case "success":
                return {className: "success", icon: "check-circle"}
            case "cancel":
                return {className: "warning", icon: "times-circle"};
            default:
                return {className: "info", icon: "info-circle"}
        }
    }
}


